import Icon, { IconType } from "@edaz/edazkit/Icon";
import { useWindowWidth } from "@react-hook/window-size";
import classNames from "classnames";
import React from "react";
import { Alert } from "react-bootstrap";
import { Variant } from "react-bootstrap/types";

export interface AlertWithInfoIconProps {
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
  onClose?: (a: any, b: any) => void;
  dismissible?: boolean;
}

export default function alertWithInfoIcon(props: AlertWithInfoIconProps) {
  const currentWidth = useWindowWidth();
  const mobileView = currentWidth <= 767;

  const updatedClassNames = classNames(
    "d-flex  align-items-center text-shadow-none py-3 font-weight-600",
    {
      "text-muted": props.variant === "light",
      "border-none": props.variant !== "warning",
    },
    props.className
  );

  return (
    <Alert
      variant={props.variant || "info"}
      className={updatedClassNames}
      onClose={props.onClose}
      dismissible={props.dismissible}>
      <div className="row">
        {!mobileView && (
          <div className="col col-auto pr-0">
            <Icon icon={IconType.Info} width={24} height={24} className="d-none d-sm-block" />
          </div>
        )}
        <div className="col">{props.children}</div>
      </div>
    </Alert>
  );
}
